






































import { mapState } from "vuex";
import CardComponent from "@/components/CardComponent.vue";

import { Component, Vue } from "vue-property-decorator";
import { Tenant } from "@/interfaces/tenants";

@Component({
  computed: {
    ...mapState(["tenants"])
  },
  components: {
    CardComponent
  }
})
export default class Home extends Vue {
  // Mapped from vuex
  tenants!: Tenant[];

  getTenantEntries(tenant: Tenant): any[] {
    return [
      {
        to: `/tenant/${tenant.tenant_id}`,
        label: "Übersicht",
        icon: "desktop-mac-dashboard"
      },
      {
        to: `/tenant/${tenant.tenant_id}/videos`,
        label: "Videos",
        icon: "library-video"
      },
      {
        to: `/tenant/${tenant.tenant_id}/photos`,
        label: "Fotos",
        icon: "image-multiple"
      },
      {
        to: `/tenant/${tenant.tenant_id}/users`,
        label: "Users",
        icon: "account-multiple"
      },
      {
        to: `/tenant/${tenant.tenant_id}/settings`,
        label: "Einstellungen",
        icon: "cogs"
      }
    ];
  }
}
